import type { Step } from "react-joyride";

export const payrollNewTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ສ້າງລາຍການເງິນເດືອນໃໝ່ສຳລັບພະນັກງານໃນເດືອນທີ່ເລືອກ. ເລືອກພະນັກງານ ແລະ ຕື່ມຂໍ້ມູນເງິນເດືອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="payroll-new-back"]',
    content: "ຍົກເລີກ ແລະ ກັບໄປຫນ້າເງິນເດືອນຕາມເດືອນ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payroll-new-form"]',
    content:
      "ເລືອກພະນັກງານ, ໃສ່ເງິນເດືອນພື້ນຖານ, OT, ເງິນອຸດໜານ ແລະ ລາຍການຫັກ. ບັນທຶກຮ່າງ ຫຼື ຢືນຢັນເພື່ອສ້າງ.",
    placement: "top",
  },
];
